export interface WarmupMelody {
  shorthand: { melody: string };
  title: string;
}

export const warmUpMelodies: WarmupMelody[] = [
  {
    shorthand: {
      melody: "1 2 3 4 5 6 7 8",
    },
    title: "Ascending Scale Warm-Up",
  },
  {
    shorthand: {
      melody: "8 7 6 5 4 3 2 1",
    },
    title: "Descending Scale Warm-Up",
  },
  {
    shorthand: {
      melody: "1 3 5 8",
    },
    title: "Arpeggio Warm-Up",
  },
  {
    shorthand: {
      melody: "8 5 3 1",
    },
    title: "Descending Arpeggio Warm-Up",
  },
  {
    shorthand: {
      melody: "1 3- 2 4- 3 5- 4 6- 5 7- 6 8",
    },
    title: "Intervallic Warm-Up",
  },
  {
    shorthand: {
      melody: "8 6- 7 5- 6 4- 5 3- 4 2- 3 1-",
    },
    title: "Descending Intervallic Warm-Up",
  },
  {
    shorthand: {
      melody: "1 3 5 1 5 3",
    },
    title: "Triad Warm-Up",
  },
  {
    shorthand: {
      melody: "8 5 1 3 5 8",
    },
    title: "Descending Triad Warm-Up",
  },
  {
    shorthand: {
      melody: "1 2- 3- 4- 5- 6- 7- 8",
    },
    title: "Sequential Warm-Up",
  },
  {
    shorthand: {
      melody: "8 7- 6- 5- 4- 3- 2- 1",
    },
    title: "Descending Sequential Warm-Up",
  },
  {
    shorthand: {
      melody: "1 5 3 8 5 1",
    },
    title: "Broken Triad Warm-Up",
  },
  {
    shorthand: {
      melody: "8 1 5 8 3 5",
    },
    title: "Descending Broken Triad Warm-Up",
  },
  {
    shorthand: {
      melody: "1 2- 3 5 4 3 2- 1",
    },
    title: "Scale + Triad Warm-Up",
  },
  {
    shorthand: {
      melody: "8 7- 6 4 5 3 2- 1",
    },
    title: "Descending Scale + Triad Warm-Up",
  },
  {
    shorthand: {
      melody: "1 2- 2 3- 3 4- 4 5- 5 6- 6 7- 7 8",
    },
    title: "Chromatic Warm-Up",
  },
  {
    shorthand: {
      melody: "8 7- 7 6- 6 5- 5 4- 4 3- 3 2- 2 1-",
    },
    title: "Descending Chromatic Warm-Up",
  },
  {
    shorthand: {
      melody: "1 3 2- 4 3- 5 4- 6 5- 7 6- 8",
    },
    title: "Interval Leap Warm-Up",
  },
  {
    shorthand: {
      melody: "8 6 7- 5 4- 6 3- 4 2- 3 1-",
    },
    title: "Descending Interval Leap Warm-Up",
  },
  {
    shorthand: {
      melody: "1- 2 3- 4 5- 6 7- 8",
    },
    title: "Dotted Rhythm Warm-Up",
  },
  {
    shorthand: {
      melody: "8- 7 6- 5 4- 3 2- 1",
    },
    title: "Descending Dotted Rhythm Warm-Up",
  },
  {
    shorthand: {
      melody: "1 2 3- 4- 5 6- 7- 8",
    },
    title: "Mixed Warm-Up",
  },
  {
    shorthand: {
      melody: "8 7 6- 5- 4 3- 2- 1",
    },
    title: "Descending Mixed Warm-Up",
  },
];
